import {Environment} from './environment.model';

export const environment: Environment = {
  baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
  serviceWorker: true,
  production: true,
};
